import React from 'react';
import { IconBase, IconBaseProps } from './IconBase';

export const Bank: React.FC<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 20 20">
    <g clipPath="url(#clip0)">
      <path d="M0.572597 17.8794H19.4274V20H0.572597V17.8794ZM3.72188 8.29522H5.80777V15.738H3.72188V8.29522ZM14.1922 8.29522H16.2781V15.738H14.1922V8.29522ZM8.95706 8.29522H11.0429V15.738H8.95706V8.29522ZM1.14519 8.10811L0 6.34096L8.83436 0.35343C8.99796 0.24255 9.17859 0.155925 9.37628 0.0935551C9.57396 0.0311847 9.78187 0 10 0C10.2181 0 10.426 0.0311847 10.6237 0.0935551C10.8214 0.155925 11.002 0.24255 11.1656 0.35343L20 6.34096L18.8548 8.10811L10 2.12058L1.14519 8.10811Z" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </IconBase>
);
